import { ContactsPermissions } from '../../Permissions/CRM';
import {
  ContactProfileManagementView,
  ContactsManagementView,
  ContactsMergeView,
  ContactsView,
  LeadsManagementView,
  LeadsProfileManagementView,
} from '../../Views/Home';
import ContactBulkUpdate from '../../Views/Home/ContactsView/BulkUpdate/ContactBulkUpdate';
import DuplicatedContactsView from '../../Views/Home/ContactsView/DuplicatedContactsView/DuplicatedContactsView';

export const ContactsCrmRoutes = [
  {
    path: '/add',
    name: 'homeLayout.contactsManagementView.Contacts-CRM',
    component: ContactsManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'homeLayout.contactsManagementView.contacts-management-view',
        isDisabled: true,
        route: '/home/Contacts-CRM/add',
      },
    ],
    hasNewLayout: true,
  },
  {
    path: '/contact-profile-edit',
    name: 'ContactProfileManagementView:contact-profile-edit',
    component: ContactProfileManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: true,
        route: '/home/Contacts-CRM/contact-profile-edit',
      },
    ],
    hasNewLayout: true,
  },
  {
    path: '/contact-profile-add',
    name: 'ContactProfileManagementView:contact-profile-add',
    component: ContactProfileManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-add',
        isDisabled: true,
        route: '/home/Contacts-CRM/contact-profile-add',
      },
    ],
  },
  {
    path: '/edit',
    name: 'homeLayout.contactsManagementView.contacts-management-view',
    component: ContactsManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'homeLayout.contactsManagementView.contacts-management-view',
        isDisabled: true,
        route: '/home/Contacts-CRM/edit',
      },
    ],
  },
  {
    path: '/view',
    name: 'ContactsView:contacts',
    component: ContactsView,
    layout: '/home/Contacts-CRM',
    default: true,
    isRoute: true,
    authorize: true,
    roles: Object.values(ContactsPermissions),
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
    ],
  },
  {
    path: '/merge',
    name: 'ContactsView:contacts',
    component: ContactsMergeView,
    layout: '/home/Contacts-CRM',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'homeLayout.contactsManagementView.merge-contacts',
        isDisabled: true,
        route: '/home/Contacts-CRM/merge',
      },
    ],
  },
  {
    path: '/addLead',
    name: 'homeLayout.contactsManagementView.contacts-management-view',
    component: LeadsManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: true,
        route: '/home/Contacts-CRM/contact-profile-edit',
      },
      {
        name: 'ContactProfileManagementView:addLead',
        isDisabled: true,
        route: '/home/Contacts-CRM/addLead',
      },
    ],
  },
  {
    path: '/lead-profile-edit',
    name: 'LeadsProfileManagementView:lead-profile-edit',
    component: LeadsProfileManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: false,
        route: '/home/Contacts-CRM/contact-profile-edit',
      },
      {
        name: 'ContactProfileManagementView:editLead',
        isDisabled: true,
        route: '/home/Contacts-CRM/lead-profile-edit',
      },
    ],
  },
  {
    path: '/leadEdit',
    name: 'homeLayout.leadsManagementView.leads-management-view',
    component: LeadsManagementView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: false,
        route: '/home/Contacts-CRM/contact-profile-edit',
      },
      {
        name: 'ContactProfileManagementView:editLead',
        isDisabled: true,
        route: '/home/Contacts-CRM/leadEdit',
      },
    ],
  },
  {
    path: '/duplicated-contacts',
    name: 'ContactProfileManagementView:duplicated-contacts',
    component: DuplicatedContactsView,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactsView:duplicated-contacts',
        isDisabled: true,
        route: '/home/Contacts-CRM/duplicated-contacts',
      },
    ],
  },
  {
    path: '/contact-bulk-update',
    name: 'ContactProfileManagementView:contact-bulk-update',
    component: ContactBulkUpdate,
    layout: '/home/Contacts-CRM',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/Contacts-CRM/view',
        groupName: 'crm',
      },
      {
        name: 'ContactsView:contact-bulk-update',
        isDisabled: true,
        route: '/home/Contacts-CRM/contact-bulk-update',
      },
    ],
  },
];
